import { useCallback, useEffect, useState } from 'react';

import { Status, Step, Steps } from '../booking.types';

export const useSteps = (): {
  steps: Step[];
  currentStep: Step;
  isFirstStep: boolean;
  isSecondStep: boolean;
  isLastStep: boolean;
  goToFirstStep: (cb?: () => void) => void;
  goToNextStep: () => void;
  goToPreviousStep: () => void;
} => {
  const [steps, setSteps] = useState([
    { label: Steps.One, status: Status.Active },
    { label: Steps.Two, status: Status.Pending },
    { label: Steps.Three, status: Status.Pending },
  ]);

  const currentStepIndex = steps.findIndex((step) => step.status === Status.Active);
  const isFirstStep = currentStepIndex === 0;
  const isSecondStep = currentStepIndex === 1;
  const isLastStep = currentStepIndex === steps.length - 1;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [currentStepIndex]);

  const goToNextStep = useCallback(() => {
    setSteps((prevSteps) =>
      prevSteps.map((step, index) => ({
        ...step,
        status:
          index === currentStepIndex + 1
            ? Status.Active
            : index <= currentStepIndex
              ? Status.Completed
              : Status.Pending,
      }))
    );
  }, [currentStepIndex]);

  const goToPreviousStep = useCallback(() => {
    // Todo: fix issue with previous
    setSteps((prevSteps) =>
      prevSteps.map((step, index) => ({
        ...step,
        status:
          index === currentStepIndex - 1
            ? Status.Active
            : index < currentStepIndex - 1
              ? Status.Completed
              : Status.Pending,
      }))
    );
  }, [currentStepIndex]);

  const goToFirstStep = useCallback((cb: () => void) => {
    setSteps((prevSteps) =>
      prevSteps.map((step, index) => ({
        ...step,
        status: index === 0 ? Status.Active : Status.Pending,
      }))
    );
    // Guarantees that the callback is called after the state update
    // This way the jsx is built and there is a div element to scroll to
    setTimeout(() => {
      cb?.();
    }, 0);
  }, []);

  return {
    steps,
    currentStep: steps[currentStepIndex],
    isFirstStep,
    isSecondStep,
    isLastStep,
    goToNextStep,
    goToPreviousStep,
    goToFirstStep,
  };
};
